import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData, statusTypesData } from "@/data";
import { editDriveLinkMutation, getReleaseQuery } from "@/graph";
import { openAlert, toggleDriveLinkDrawer } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useEditDriveLink = (linkId, entityId, entityType) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [editDriveLinkAction, { loading }] = useMutation(editDriveLinkMutation, {
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: getReleaseQuery,
                variables: {
                    where: { id: entityId },
                },
            },
        ],
    });

    const editDriveLink = async (data) => {
        try {
            await editDriveLinkAction({
                onCompleted: () => {
                    dispatch(toggleDriveLinkDrawer(false));

                    dispatch(
                        openAlert(
                            t("messages.editMsgs.success", { entity: `${entityType} ${t("labels.driveLink")}` }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: {
                    id: linkId,
                    name: data?.resourceName,
                    url: data?.driveLink,
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        editDriveLink,
        loading,
    };
};

export default useEditDriveLink;
